import { Col, Form, Radio, Row, Typography } from "antd";
import { RadioChangeEvent } from "antd/lib";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import useMazakaForm from "hooks/useMazakaForm";
import { FC, useEffect, useState } from "react";

interface DetailsInfoesProps {
  data: any;
  setData: any;
  id: string;
  title: string;
  onFinish: any;
}

const DetailsInfoes: FC<DetailsInfoesProps> = (props) => {
  const [radioValue, setRadioValue] = useState(1);

  const onChange = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
    setRadioValue(e.target.value);
  };

  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { Text } = Typography;

  const options = [
  
    { label: "Hafif Çizik", value: 2 },
    { label: "Derin Çizik", value: 3 },
    { label: "Hafif Ezik", value: 4 },
    { label: "Dolu Eziği", value: 5 },
    { label: "Sürtme", value: 6 },
    { label: "Taş İzi", value: 7 },
    { label: "Göçük", value: 8 },
    { label: "Kırık / Çatlak", value: 9 },
    { label: "Yırtık", value: 10 },
    { label: "Çıkmayan Leke - Kuş, Ağaç Pisliği", value: 11 },
    { label: "Renk Solması", value: 12 },
    { label: "Güneş Yanığı", value: 13 },
    { label: "Paslanma / Oksitlenme", value: 14 },
    { label: "Mini Onarım / Tamir", value: 15 },
    { label: "Boyasız Göçük Düzeltme", value: 16 },
  ];

  useEffect(() => {
    const allData = [...props.data];
    const findItem = allData.find((item) => item.key === props.id);
    if (findItem?.status?.orginal) {
      setRadioValue(1);
    } else if (findItem?.status?.localPainted) {
      setRadioValue(2);
    } else if (findItem?.status?.painted) {
      setRadioValue(3);
    } else if (findItem?.status?.changed) {
      setRadioValue(4);
    }
    form.setFieldValue("descValue", findItem?.status?.descValue);
  }, [props.id, props.data]);

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    try {
      const descValue = form.getFieldValue("descValue") || null;
      const allData = [...props.data];
      const findIndex = allData.findIndex((item) => item.key === props.id);
      if (findIndex === -1) {
        return mazakaForm.setFailed(2000, "Veri bulunamadı!");
      }
      const statusKeys = ["orginal", "localPainted", "painted", "changed"];
      statusKeys.forEach((key, index) => {
        allData[findIndex].status[key] = radioValue === index + 1;
      });
      allData[findIndex].status.descValue = descValue;

      // Find the label of the selected option for descTitle
      const selectedOption = options.find((option) => option.value === descValue);
      allData[findIndex].status.descTitle = selectedOption ? selectedOption.label : null;

      form.resetFields();
      await props.setData(allData);
      mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
      props.onFinish();
    } catch (error) {
      mazakaForm.setFailed(2000, "Veri güncellemesi başarısız!");
    }
  };

  return (
    <Col xs={24}>
      <MazakaForm
        form={form}
        onFinish={handleOnFinish}
        submitButtonXPosition="left"
        {...formActions}
      >
        <Row gutter={[0, 20]}>
          <Col xs={24}>
            <Text>
              <span className="!text-2xl">
                Parça Adı: <span className="!text-2xl font-bold">{props.title}</span>
              </span>
            </Text>
          </Col>
          <Col xs={24}>
            <Radio.Group onChange={onChange} value={radioValue}>
              <Radio value={1}>Orijinal</Radio>
              <Radio value={2}>Lokal Boyalı</Radio>
              <Radio value={3}>Boyalı</Radio>
              <Radio value={4}>Değişen</Radio>
            </Radio.Group>
          </Col>
          <MazakaSelect
            xs={24}
            placeholder="Seç"
            label="Detay"
            options={options}
            name={"descValue"}
          />
        </Row>
      </MazakaForm>
    </Col>
  );
};

export default DetailsInfoes;
